/**
 * @copyright Copyright 2018 The MathWorks, Inc.
 * @description Enumeration of dialog roles. <br />
 * A model dialog can also be an alert dialog. A modal dialog
 * can be set as an alert dialog by setting the role.
 *
 * @module mw-dialogs/enums/RoleEnum
 */
define([
],function () {
    /**
     * @member Role
     * @description Enum of dialog roles
     * @readonly
     * @static
     * @property {string} ALERT_DIALOG - Alert dialog role
     * @example Role.ALERT_DIALOG
     */
    const Role = Object.freeze({
        DIALOG: 'dialog',
        ALERT_DIALOG: 'alertdialog'
    });

    return Role;
});